var throttle = require( 'lodash.throttle' ),
  debounce = require( 'lodash.debounce' );

/**
 * Initializes the site header.
 * @constructor
 * @param {Object} el - The site header element.
 */
function Header(el) {
  var t = this;

  t.el = el;
  t.anchor = document.querySelector( '[data-header-scroll-anchor]' );
  t.threshold = 0;

  if ( t.anchor ) {
    t.calculateThreshold();
    t.checkScroll();

    console.log(t.threshold);
    window.addEventListener( 'resize', debounce( function () {
      t.calculateThreshold();
      t.checkScroll();
    } ) );
    window.addEventListener( 'scroll', throttle( t.checkScroll.bind( t ) ) );
  }
}

Header.prototype.checkScroll = function () {
  var t = this,
    scrollTop = window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop || 0;

  if ( scrollTop > t.threshold ) {
    document.documentElement.classList.add( 'js-header-fixed' );
  } else {
    document.documentElement.classList.remove( 'js-header-fixed' );
  }
};

Header.prototype.calculateThreshold = function () {
  var t = this;
  t.threshold = t.anchor.offsetTop;
};

module.exports = Header;